import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import { format } from 'sql-formatter';
import { CodeBlock, atomOneDark} from 'react-code-blocks';
import Button from '@mui/material/Button';
import SftGlobalData from '../library/SftGlobalData';
import axios from 'axios';
import { ListItemText, TextField } from '@mui/material';
import Colors from '../library/Colors';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
  
  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }


const RevenueSettingsForm = (props) =>  {
    const [stores, setStores] = useState(props.settings.stores.split(','));
    const [pos, setPos] = useState ([]);
    const [selectedStore, setSelectedStore] = useState([]);
    const [selectedPos, setSelectedPos] = useState([]);
    const query = "SET @date = '2022-05-16';";
    const query2 = "DROP TABLE IF EXISTS t_date_to_check;";
    const query3 = "SELECT @date AS date_now, IF(YEAR(@date) - YEAR(DATE_SUB(@date, INTERVAL IF(WEEK(CONCAT(YEAR(@date),'-12-31'), 3) = 1, 52, IF(WEEK(CONCAT(YEAR(@date),'-12-31'), 3) >52, 52, WEEK(CONCAT(YEAR(@date),'-12-31'), 3))) WEEK)) > 1, DATE_SUB(@date, INTERVAL IF(WEEK(CONCAT(YEAR(@date),'-12-31'), 3) = 1, 52, IF(WEEK(CONCAT(YEAR(@date),'-12-31'), 3) >52, 52, WEEK(CONCAT(YEAR(@date),'-12-31'), 3))) WEEK), DATE_SUB(@date, INTERVAL IF(WEEK(CONCAT(YEAR(@date),'-12-31'), 3) = 1, 52, IF(WEEK(CONCAT(YEAR(@date),'-12-31'), 3) >52, 52, WEEK(CONCAT(YEAR(@date),'-12-31'), 3))) WEEK)) AS prevYearDate;";
    const [query4, setQuery4] = useState(props.settings.custom);
    const [showQueries, setShowQueries] = useState(false);
    const [storeEquals, setStoreEquals] = useState(props.settings.stores_in);
    const [posEquals, setPosEquals] = useState(props.settings.pos_in);

    //const [oldSelectedStore, setOldSelectedStore] = useState(props.settings.stores);
    //const [oldSelectedPos, setOldSelectedPos] = useState(props.settings.pos);

    const theme = useTheme();

    const generateAppJson = () => {
        let storesData = ""; 
        selectedStore.forEach(element => {
            if(storesData !== ""){
                storesData += ", ";
            }
            storesData += "'" + element.substring(0,2) + "'";
        });

        let posData = ""; 
        selectedPos.forEach(element => {
            if(posData !== ""){
                posData += ", ";
            }
            posData += "'" + element.substring(0,4) + "'";
        });

        return {stores: storesData, pos: posData, stores_in: storeEquals, pos_in: posEquals, custom: query4.replaceAll('"', "'")};
    }

    const customQueryPart = () => {
        let storesData = ""; 
        selectedStore.forEach(element => {
            if(storesData !== ""){
                storesData += ", ";
            }
            storesData += "'" + element.substring(0,2) + "'";
        });

        let posData = ""; 
        selectedPos.forEach(element => {
            if(posData !== ""){
                posData += ", ";
            }
            posData += "'" + element.substring(0,4) + "'";
        });

        let result = "";
        if(selectedStore.length > 0){
            result += " AND kasticket_.mag " + (storeEquals ? "IN " : "NOT IN ") + "(" + storesData + ") ";
        }
        if(selectedPos.length > 0){
            result += " AND kasticket_.kassa_id " + (posEquals ? "IN " : "NOT IN ") + "(" + posData + ") ";
        }

        return result;
    }

    /*useEffect(()=>{
        let testing = props.settings.stores.replaceAll(" ", "");
        testing = testing.replaceAll("'", "");
        setOldSelectedStore(testing.split(","));
        console.log('splittedStores', testing.split(","));
    }, [props.settings.stores]);*/

    /*useEffect(()=>{
        let testing = props.settings.pos.replaceAll(" ", "");
        testing = testing.replaceAll("'", "");
        setOldSelectedPos(testing.split(","));
        console.log('splittedPos', testing.split(","));
    }, [props.settings.pos]);*/

    useEffect(() => {
        if(props.api !== ""){
            SftGlobalData.post('sftData', {key: props.api, type: "stores"}).then(response => {
                setStores(response.data);
                let selected = props.settings.stores.replaceAll(" ", "");
                selected = selected.replaceAll("'", "");
                selected = selected.split(",");
                let selectedStoresArray = [];
                response.data.forEach(element => {
                    if(selected.includes(element.code)){
                        selectedStoresArray.push(element.code+" - "+element.oms);
                    }
                });
                setSelectedStore(selectedStoresArray);
            });

            SftGlobalData.post('sftData', {key: props.api, type: "pos"}).then(response => {
                setPos(response.data);
                let selected = props.settings.pos.replaceAll(" ", "");
                selected = selected.replaceAll("'", "");
                selected = selected.split(",");
                let selectedPosArray = [];
                response.data.forEach(element => {
                    if(selected.includes(element.code)){
                        selectedPosArray.push(element.code+" - "+element.oms);
                    }
                });
                setSelectedPos(selectedPosArray);
            });
        }
    },[props.api, props.settings.stores, props.settings.pos]);

    useEffect(() => {
        //console.log('testloop');
        props.setJson(generateAppJson());
    },[selectedPos, selectedStore, storeEquals, posEquals, query4, props]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedStore(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    const handleChangePos = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedPos(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
  return (
    <div>
        <br/>
        <label className='margin_bottom_5px' htmlFor="store_filter">Store filter:</label>
        <Button onClick={()=>{setStoreEquals(!storeEquals)}} className={(storeEquals ? 'green' : 'red')+" toggleButtonSmall align_right"} type="button">{storeEquals ? "=" : "≠"}</Button>
        <FormControl sx={{ width: '100%', marginTop: 1, marginBottom: 3 }}>
            <InputLabel id="demo-multiple-chip-label" className={props.theme+"_accent "+props.theme+"_text border_radius_top"}>Store</InputLabel>
            <Select
            style={{marginBottom:10}}
            className={props.theme+"_accent "+props.theme+"_text"}
            labelId="demo-multiple-chip-label"
            id="demo-multiple-chip"
            multiple
            value={selectedStore}
            onChange={handleChange}
            input={<OutlinedInput id="select-multiple-chip" label="Store" />}
            renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                    <Chip key={value} label={value} className={props.theme+"_accent_darker "+props.theme+"_text"}/>
                ))}
                </Box>
            )}
            MenuProps={MenuProps}
            >
            {stores.map((store) => (
                <MenuItem
                key={store.code}
                value={store.code+" - "+store.oms}
                style={getStyles(store.oms, selectedStore, theme)}
                >
                    <Checkbox checked={selectedStore.indexOf(store.code+" - "+store.oms) > -1} />
                    <ListItemText primary={store.code+" - "+store.oms}/>
                </MenuItem>
            ))}
            </Select>
        </FormControl>

        <label className='margin_bottom_5px' htmlFor="pos_filter">POS filter:</label>
        <Button onClick={()=>{setPosEquals(!posEquals)}} className={(posEquals ? 'green' : 'red')+" toggleButtonSmall align_right"} type="button">{posEquals ? "=" : "≠"}</Button>

        <FormControl sx={{ width: '100%', marginTop: 1, marginBottom: 3 }}>
            <InputLabel id="demo-multiple-chip-label-pos" className={props.theme+"_accent "+props.theme+"_text border_radius_top"}>POS</InputLabel>
            <Select
            className={props.theme+"_accent "+props.theme+"_text"}
            labelId="demo-multiple-chip-label-pos"
            id="demo-multiple-chip-pos"
            multiple
            value={selectedPos}
            onChange={handleChangePos}
            input={<OutlinedInput id="select-multiple-chip-pos" label="POS" />}
            renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                    <Chip key={value} label={value} className={props.theme+"_accent_darker "+props.theme+"_text"}/>
                ))}
                </Box>
            )}
            MenuProps={MenuProps}
            >
            {pos.map((pos) => (
                <MenuItem
                key={pos.code}
                value={pos.code+" - "+pos.oms}
                style={getStyles(pos.oms, selectedPos, theme)}
                >
                    <Checkbox checked={selectedPos.indexOf(pos.code+" - "+pos.oms) > -1} />
                    <ListItemText primary={pos.code+" - "+pos.oms}/>
                </MenuItem>
            ))}
            </Select>
        </FormControl>
        <label className='margin_bottom_5px' htmlFor="custom_query">Custom filter:</label>
        <FormControl sx={{ width: '100%', marginTop: 1, marginBottom: 3 }}>
            <TextField
                type='text'
                name="custom_query" 
                onChange={(event)=>{setQuery4(event.target.value)}}                                 
                id="custom_query" 
                multiline
                className={props.theme+"_accent "+props.theme+"_text"}
                value={query4}
                sx={{
                '& .MuiOutlinedInput-input': {
                    color: props.theme === 'dark' ? Colors.dark_text : Colors.light_text
                }}}
                label={'Custom filter'}
            />
        </FormControl>
        <legend className='_100perc'>
            Show queries
            <label className="switch align_right">
                <input type="checkbox" checked={showQueries} onChange={()=>{setShowQueries(!showQueries)}}/>
                <span className={"slider slider_" + props.theme + " round"}></span>
            </label>
        </legend>
        {showQueries && <hr/>}
        {showQueries && <CodeBlock 
            text={format(query + " " + query2 + " " + query3)}
            style={{marginBottom: 10}}
            language={'sql'}
            theme={atomOneDark}
            {...{ showLineNumbers: true, wrapLines: true, codeBlock: true }}
            />}
        {showQueries && <br/>}
        {showQueries && <CodeBlock 
            text={format("SELECT IFNULL(kasticket_.ticketnr, 0) AS ticketnr, CAST(t_date_to_check.`date_now` AS DATE) AS datum, CAST(t_date_to_check.prevYearDate AS DATE) AS prev_year_date, WEEK(t_date_to_check.`date_now`, 3) AS week_of_year, IFNULL(magazijn.`oms`, '') AS 'mag', IFNULL(kassa.`oms`, '') AS 'kassa_id', IFNULL(kasticket_.userid, '0000') AS 'userid', IFNULL(kasticket_.barcode, 0) AS barcode, IFNULL(kasticket_.ktbarcode, 0) AS ktbarcode, IFNULL(kasticket_.aantal, 0) AS aantal, IFNULL(kasticket_.t_goed, 0) AS t_goed, IFNULL(kasticket_.t_korting, 0) AS t_korting, IFNULL(kasticket_.t_totaal, 0) AS t_totaal, IFNULL(kasticket_.vatpct, 21) AS vatpct, IFNULL(voorraad.`barbody`, '999999') AS barbody, CASE WHEN voorraad.`barbody` = '999901' THEN '' WHEN voorraad.`barbody` = '999902' THEN '' WHEN voorraad.`barbody` = '999903' THEN '' WHEN voorraad.`barbody` = '999904' THEN '' WHEN voorraad.`barbody` = '999905' THEN '' WHEN voorraad.`barbody` = '999906' THEN '' WHEN voorraad.`barbody` = '999907' THEN '' WHEN voorraad.`barbody` = '999908' THEN '' WHEN voorraad.`barbody` = '999909' THEN '' WHEN voorraad.`barbody` = '999998' THEN '' WHEN kasticket_.`barcode` = '99999999999995' THEN '' WHEN kasticket_.`barcode` = '99999999999999' THEN '' WHEN kasticket_.`barcode` LIKE '99999701%' THEN '' ELSE IFNULL(seizoen.`oms`, 'no_value') END AS seizoen, CASE WHEN voorraad.`barbody` = '999901' THEN 'retouche' WHEN voorraad.`barbody` = '999902' THEN 'gift_voucher' WHEN voorraad.`barbody` = '999903' THEN 'advance' WHEN voorraad.`barbody` = '999904' THEN 'voucher' WHEN voorraad.`barbody` = '999905' THEN 'customer_discount' WHEN voorraad.`barbody` = '999906' THEN 'giftlist' WHEN voorraad.`barbody` = '999907' THEN 'commercial_voucher' WHEN voorraad.`barbody` = '999908' THEN 'discount_type' WHEN voorraad.`barbody` = '999909' THEN 'customer_discount_voucher' WHEN voorraad.`barbody` = '999998' THEN 'order' WHEN kasticket_.barcode = '99999999999995' THEN 'diverse_article' WHEN kasticket_.barcode = '99999999999999' THEN 'other' WHEN kasticket_.`barcode` LIKE '99999701%' THEN 'import_cheque' ELSE IFNULL(leverancier.`naam`, 'no_value') END AS levnr, CASE WHEN voorraad.`barbody` = '999901' THEN 'retouche' WHEN voorraad.`barbody` = '999902' THEN 'gift_voucher' WHEN voorraad.`barbody` = '999903' THEN 'advance' WHEN voorraad.`barbody` = '999904' THEN 'voucher' WHEN voorraad.`barbody` = '999905' THEN 'customer_discount' WHEN voorraad.`barbody` = '999906' THEN 'giftlist' WHEN voorraad.`barbody` = '999907' THEN 'commercial_voucher' WHEN voorraad.`barbody` = '999908' THEN 'discount_type' WHEN voorraad.`barbody` = '999909' THEN 'customer_discount_voucher' WHEN voorraad.`barbody` = '999998' THEN 'order' WHEN kasticket_.barcode = '99999999999995' THEN 'diverse_article' WHEN kasticket_.barcode = '99999999999999' THEN 'other' WHEN kasticket_.`barcode` LIKE '99999701%' THEN 'import_cheque' ELSE IFNULL(c1.`codeoms`, 'no_value') END AS code1, CASE WHEN voorraad.`barbody` = '999901' THEN 'retouche' WHEN voorraad.`barbody` = '999902' THEN 'gift_voucher' WHEN voorraad.`barbody` = '999903' THEN 'advance' WHEN voorraad.`barbody` = '999904' THEN 'voucher' WHEN voorraad.`barbody` = '999905' THEN 'customer_discount' WHEN voorraad.`barbody` = '999906' THEN 'giftlist' WHEN voorraad.`barbody` = '999907' THEN 'commercial_voucher' WHEN voorraad.`barbody` = '999908' THEN 'discount_type' WHEN voorraad.`barbody` = '999909' THEN 'customer_discount_voucher' WHEN voorraad.`barbody` = '999998' THEN 'order' WHEN kasticket_.barcode = '99999999999995' THEN 'diverse_article' WHEN kasticket_.barcode = '99999999999999' THEN 'other' WHEN kasticket_.`barcode` LIKE '99999701%' THEN 'import_cheque' ELSE IFNULL(c2.`codeoms`, 'no_value') END AS code2, CASE WHEN voorraad.`barbody` = '999901' THEN 'retouche' WHEN voorraad.`barbody` = '999902' THEN 'gift_voucher' WHEN voorraad.`barbody` = '999903' THEN 'advance' WHEN voorraad.`barbody` = '999904' THEN 'voucher' WHEN voorraad.`barbody` = '999905' THEN 'customer_discount' WHEN voorraad.`barbody` = '999906' THEN 'giftlist' WHEN voorraad.`barbody` = '999907' THEN 'commercial_voucher' WHEN voorraad.`barbody` = '999908' THEN 'discount_type' WHEN voorraad.`barbody` = '999909' THEN 'customer_discount_voucher' WHEN voorraad.`barbody` = '999998' THEN 'order' WHEN kasticket_.barcode = '99999999999995' THEN 'diverse_article' WHEN kasticket_.barcode = '99999999999999' THEN 'other' WHEN kasticket_.`barcode` LIKE '99999701%' THEN 'import_cheque' ELSE IFNULL(c3.`codeoms`, 'no_value') END AS code3, IFNULL(curOntvBoek.`weather_type_id`, 0) AS cur_weather_type_id, IFNULL(klant.`postcode`, 0000) AS postcode, IFNULL(klant.`landcode`, 'XX') AS landcode, IF(IFNULL(TIMESTAMPDIFF(YEAR, klant.`gebdatum`, CURDATE()), -1) > 122, -1, IFNULL(TIMESTAMPDIFF(YEAR, klant.`gebdatum`, CURDATE()), -1)) AS age FROM t_date_to_check LEFT JOIN kasticket_ ON kasticket_.`datum` = t_date_to_check.`date_now` LEFT JOIN ontvboek AS curOntvBoek ON t_date_to_check.`date_now` = curOntvBoek.`datum` AND kasticket_.`kassa_id` = curOntvBoek.`kassa_id` LEFT JOIN ontvboek AS OldOntvBoek ON t_date_to_check.prevYearDate = OldOntvBoek.`datum` LEFT JOIN voorraad ON voorraad.barcode = kasticket_.barcode LEFT JOIN codes c1 ON voorraad.`code1` = c1.`totcode` LEFT JOIN codes c2 ON voorraad.`code2` = c2.`totcode` LEFT JOIN codes c3 ON voorraad.`code3` = c3.`totcode` LEFT JOIN seizoen ON voorraad.`seizoen` = seizoen.`seizoen` LEFT JOIN leverancier ON voorraad.`levnr` = leverancier.`levnr` LEFT JOIN klant ON kasticket_.`klnr` = klant.`klnr` LEFT JOIN magazijn ON magazijn.`code` = kasticket_.`mag` LEFT JOIN kassa ON kassa.code = kasticket_.`kassa_id` WHERE (curOntvBoek.`datum` IS NOT NULL OR OldOntvBoek.`datum` IS NOT NULL) /* STORE / POS FILTER */ " + customQueryPart() + " /* START CUSTOM FILTER */" + query4 + " /* END CUSTOM FILTER */ GROUP BY kasticket_.`ticketnr`, kasticket_.`lijn`;")}
            style={{marginBottom: 10}}
            language={'sql'}
            theme={atomOneDark}
            {...{ showLineNumbers: true, wrapLines: true, codeBlock: true }}
            />}
    </div>
  );
}

export default RevenueSettingsForm;
